/**
 * Faceted Search - Async - Show results button
 */

(() => {
    let form = document.querySelector('.js-faceted-search-form');
    let button = document.querySelector('.js-show-results-button');
    let text_field = document.querySelector('.js-faceted-search-text-field');

    if (!form || !button) {
        return;
    }

    function updateButtonLabel() {
        let label = button.querySelector('.js-show-results-button-label');

        if (!label) {
            return;
        }

        const results = H_Tools.search.getResults();

        if (!results) {
            return;
        }

        label.innerHTML =
            button.getAttribute('data-label') +
            ' (' +
            results.getAttribute('data-posts-total') +
            ')';
    }

    function enableButton() {
        button.disabled = false;
        button.classList.remove('-loading');
        button.removeAttribute('title');
    }

    function disableButton() {
        button.disabled = true;
        button.classList.add('-loading');
        button.setAttribute('title', button.getAttribute('data-loading'));
    }

    function onSubmit(e) {
        e.preventDefault();
        H_Tools.search.showResults();
    }

    /**
     * Remove the '#search-results' hash from the URL. This allows for setting the hash again to
     * jump to results, which the browser would not do if the hash is already in the URL.
     */
    function clearResultsHash() {
        if (location.hash === '#search-results') {
            history.replaceState(null, '', location.pathname + location.search);
        }
    }

    function checkFocus() {
        // console.log('Checking focus...');

        if (
            document.activeElement.classList.contains('js-link-collection-link')
        ) {
            H_Tools.search.focusWaitButton();
            H_Tools.search.focus_results_on_settle = true;
        }
    }

    function updateLiveRegion() {
        let live_region = form.querySelector('.js-faceted-search-live-region');

        if (!live_region) {
            return;
        }

        const results = form.querySelector('.js-faceted-search-results-amount');

        if (!results) {
            return;
        }

        live_region.innerHTML = results.innerHTML;
    }

    form.addEventListener(
        'input',
        (e) => (H_Tools.search.results_are_stale = true)
    );
    form.addEventListener('submit', onSubmit);
    form.addEventListener('htmx:beforeRequest', (e) => {
        H_Tools.search.requests_active++;
        disableButton();
        checkFocus();
    });
    form.addEventListener('htmx:afterOnLoad', (e) => {
        H_Tools.search.requests_active--;
        enableButton();
    });
    form.addEventListener('htmx:afterSettle', (e) => {
        updateButtonLabel();
        updateLiveRegion();

        H_Tools.search.results_are_stale = false;
        if (H_Tools.search.focus_results_on_settle) {
            H_Tools.search.focusResults();
        }
    });
    button.addEventListener('click', H_Tools.search.showResults);
    button.addEventListener('focus', clearResultsHash);
    text_field?.addEventListener('focus', clearResultsHash);

    updateButtonLabel();
})();
